import chunk from 'chunk'
import qr from 'qr-image'

import logo from '../assets/images/logo_thai_run_B.png'

export const labelHeader = `
<div class="label-header">
  <div class="logo"><img src="${logo}" /></div>
  <div class="sender">
    Thaidotrun Co., Ltd.<br />
    803 โครงการ stadium One <br />
    ซอย จุฬาลงกรณ์ 4 ถนน บรรทัดทอง  <br />
    แขวง วังใหม่ เขต ปทุมวัน กรุงเทพฯ 10330
  </div>
</div>
`
export const genLabel = createLabel => (data, sponsor) => {
  const labelQrcode = label => `
${sponsor ? `
<div class="sponsor">
  <div><img src="${sponsor}" /></div>
</div>
` : ''}
<div class="qrcode">
  ${qr.imageSync(JSON.stringify({ app: 'thairun', id: label._id }), { type: 'svg' })}<br />
  ${label._id || 'TEST000000'}
</div>
<div class="label-id">
  (${label.data.count} ชิ้น)<br />
  ถุงที่ ${label.seq}/${label.last}
</div>
`
  const createRow = row => `
<tr>
  ${row.map(label => createLabel(label, labelQrcode)).join('\n')}
</tr>`
  const createPage = labels => `
<table style="page-break-after: always;">
  ${chunk(labels, 1).map(row => createRow(row)).join('\n')}
</table>`

  const html = `
<html>
  <style>
    @import url('https://fonts.googleapis.com/css?family=Kanit');
    body{
      margin: 0px;
      font-family: 'Kanit', sans-serif;
    }
    td {
      vertical-align: top;
      text-align: left;
      font-size: 12px;
    }
    table {
      border-collapse: collapse;
      width: 10.2cm;
    }
    .main-cell {
      max-width: 10.2cm;
      width: 10.2cm;
      max-height: 14.8cm;
      height: 14.8cm;
      position: relative;
    }
    .gap-hor td {
      width: 4.15in;
      padding: 0;
    }
    .label {
      margin: 0.3cm;
    }
    .qrcode {
      bottom: 10px;
      right: 0.3cm;
      width: 2.5cm;
      position: absolute;
      background: #fff;
      text-align: center;
    }
    .label-id {
      position: absolute;
      bottom: 10px;
      right: 3cm;
      text-align: right;
    }
    .label-header {
      display: flex;
      margin-bottom: 0.2cm;
      border-bottom: 1px solid #000;
      font-size: 11px;
    }
    .label-header .logo img {
      width: 1in;
    }
    .label-header .sender {
      width: 2.65in;
      margin-bottom: 5px;
    }
    .recipient {
      font-size: 13px;
      font-weight: bold;
    }
    .sponsor {
      position: absolute;
      bottom: 10px;
      left: 0.3cm;
      width: 5cm;
    }
    .sponsor img {
      max-width: 5cm;
      max-height: 2.5cm;
    }
    .recipient, .event {
      margin-bottom: 0.2cm;
    }
    .items {
      font-size: 11px;
    }
  </style>
  <body>
    ${chunk(data, 1).map(page => createPage(page)).join('\n')}
  </body>
</html>
`
  return html
}

export default {
  genLabel,
}



// WEBPACK FOOTER //
// ./src/helpers/label.js